import React, { Suspense, useEffect, useRef, useState } from "react";
import logo from "./../assets/logo_flat.png";
import {
  getDocDataById,
  getDocDataByRef,
  listenDocDataByIdX,
} from "../models/DataFunctions";
import { logoutUser, useAuth } from "../auth/FirebaseAuth";
import { Org, User } from "../types/basicTypes";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import { useSnackbar } from "notistack";
import Icon1 from "../assets/icons/Icon";
import NavBar from "./NavBar";
import ParametersNavBar from "./ParametersNavBar";
import loginAs from "../api/loginAs";
import { useAppContext } from "./AppContext";
import { signInWithCustomToken } from "firebase/auth";
import { auth } from "./FirebaseConfig";
import RoutesManager from "./RoutesManager";
import SecondaryButton from "../buttons/SecondaryButton";
import Gleap from "gleap";
import { getOrRefreshFirebaseToken } from "./getFirebaseToken";
import startGleapSession from "../api/auth/startGleapSession";
import imageLogo from "../assets/logo_flat.png"; // Adjust the path as necessary

function App() {
  const { currentUser, loading } = useAuth();
  const { enqueueSnackbar } = useSnackbar();
  const [userData, setUserData] = useState<User | null>(null);
  const [orgData, setOrgData] = useState<Org | null>(null);
  const [masterData, setMasterData] = useState<any>(null);
  const { appState, setAppState, fetchCarnets, resetAppStateLogin } =
    useAppContext();
  const prefix = appState.dev ? appState.dev_url : appState.prod_url;

  const getPageFromPath = (path: string) => {
    if (path.includes("folder")) {
      return "folder";
    }
    if (path.includes("home")) {
      return "home";
    }
    if (path.includes("xml")) {
      return "xml";
    }
    if (path.includes("attestation")) {
      return "attestation";
    }
    if (path.includes("partner")) {
      return "partner";
    }
    if (path.includes("appareil")) {
      return "appareil";
    }
    if (path.includes("document")) {
      return "document";
    }
    if (path.includes("account")) {
      return "settings";
    }
    if (path.includes("organisation")) {
      return "settings";
    }
    if (path.includes("option")) {
      return "settings";
    }
    if (path.includes("atec")) {
      return "settings";
    }
    if (path.includes("logs")) {
      return "admin";
    }
    if (path.includes("org")) {
      return "admin";
    }
    if (path.includes("user")) {
      return "admin";
    }
    if (path.includes("template")) {
      return "template";
    }
    if (path.includes("rtb")) {
      return "settings";
    }
    if (path.includes("facturation")) {
      return "settings";
    }
    if (path.includes("ath")) {
      return "settings";
    }
    if (path.includes("partner")) {
      return "partner";
    }
    return "";
  };
  const location = useLocation();

  const actualpage = getPageFromPath(location.pathname);

  const handleClickVariant = (
    message: string,
    variant: "default" | "error" | "success" | "warning" | "info" | undefined
  ) => {
    enqueueSnackbar(message, { variant });
  };

  let x_pages = [
    "home",
    "xml",
    "rtb",
    "attestation",
    "recharge",
    "parameters",
    "settings",
    "document",
    "admin",
    "partner",
    "template",
  ];

  let isinside = x_pages.includes(actualpage);
  let isinparameters = actualpage === "settings";

  const [version, setVersion] = useState<string>("");
  const [messageNewVersion, setMessageNewVersion] = useState(false);
  useEffect(() => {
    fetch("/version.txt")
      .then((response) => response.text())
      .then((text) => setVersion(text))
      .catch((error) => console.error("Error fetching version:", error));
  }, []);
  const [loadingVersion, setLoadingVersion] = useState(false);

  const isProd = !window.location.href.includes("localhost");
  const handleSetOrgData = (data: any) => {
    setOrgData(data);
  };

  const handleSetUserData = (data: any) => {
    setUserData(data);
  };

  const [updateListeners, setUpdateListeners] = useState<any>({});

  const handleFetchData = async (currentUser: any) => {
    if (currentUser) {
      try {
        const user = (await getDocDataById(
          "user",
          currentUser.uid
        )) as any as User;
        if (!user) {
          console.error("user not found ");
          if (isinside) {
            navigateWorkspace("/login");
          }

          return;
        }
        if (currentUser) {
          initializeGleapSession();
        }

        const org = (await getDocDataById("org", user.org_id)) as any as Org; // Récupère l'organisation par référence
        if (!org) {
          navigateWorkspace("/setup");
          console.error("org not found");
          return;
        }
        await fetchCarnets(org);

        console.log("org", org);

        setOrgData(org);

        setUserData(user);

        console.log("userData", user);
        setUpdateListeners({
          user_id: user.id,
          org_id: org.id,
        });
      } catch (error) {
        console.error(
          "Erreur lors de la récupération de l'organisation:",
          error
        );
      }
    }
  };

  useEffect(() => {
    if (!currentUser && !loading) {
      if (isinside) {
        navigate("/login");
      } else {
      }
    }
    handleFetchData(currentUser);
  }, [currentUser, loading]); // Add overrideId() to the dependency array
  const unsubscribeUserData = useRef<(() => void) | null>(null);
  const unsubscribeOrgData = useRef<(() => void) | null>(null);
  const unsubscribeMasterData = useRef<(() => void) | null>(null);
  useEffect(() => {
    // updateListeners is an array of functions that will be called when the orgData is updated
    if (updateListeners.user_id) {
      listenDocDataByIdX(
        "user",
        updateListeners.user_id,
        handleSetUserData,
        unsubscribeUserData
      );
    }

    if (updateListeners.org_id) {
      listenDocDataByIdX(
        "org",
        updateListeners.org_id,
        handleSetOrgData,
        unsubscribeOrgData
      );
    }

    return () => {
      if (unsubscribeUserData.current) {
        unsubscribeUserData.current();
      }
      if (unsubscribeOrgData.current) {
        unsubscribeOrgData.current();
      }
    };
  }, [updateListeners]);

  const handleSetVersion = (value: any) => {
    const LOCAL_VERSION = version || 5;
    console.log("LOCAL_VERSION", LOCAL_VERSION);
    if (LOCAL_VERSION !== value.react_version.toString()) {
      // value.react_version is a number
    } else {
    }
    console.log("LOCAL_VERSION", LOCAL_VERSION);
    console.log(
      "value.react_version.toString()",
      value.react_version.toString()
    );

    console.log("value", value);

    if (!isProd) {
      return;
    }

    if (isNaN(value.react_version)) {
      // should not happen
      //sendErrorDiscord("VERSION IS NOT A NUMBER", prefix);
      return;
    }
    if (value.react_version > LOCAL_VERSION) {
      handleClickVariant("Nouvelle version disponible", "success");
      setMessageNewVersion(true);
      setLoadingVersion(false);
    }
  };

  const unsubscribeMaintenance = useRef(null);
  const unsubscribeMaintenanceChill = useRef(null);
  const unsubscribeMaintenanceStatus = useRef(null);

  const unsubscribeVersion = useRef(null);

  const initializeGleapSession = async () => {
    Gleap.initialize("jvywupnzLILc2RRr01Lg2oSUgLtDFQFW");
    Gleap.setLanguage("fr");
    if (!auth?.currentUser) {
      console.warn("Gleap not initialized, no user logged in");
      return;
    }
    const token = await getOrRefreshFirebaseToken();
    let data = await startGleapSession(token, prefix);
    if (data) {
      Gleap.identify(
        data.user_id,
        {
          name: data.name,
          email: data.email,

          phone: data.phone,
          value: data.value,
          plan: data.plan,
          companyId: data.companyId,
          companyName: data.companyName,
          // Passing the createdAt property allows you to set the correct createdAt date. (optional)
          // createdAt: data.createdAt ? new Date(data.createdAt * 1000) : null,
          // customData: {
          //   type: data.customData.type,
          //   master_id: data.customData.master_id,
          //   master_name: data.customData.master_name,
          //   master_email: data.customData.master_email,
          // },
        },

        data.gleap_user_hash
      );
    }

    // 🔧 Wait for Gleap to inject itself, then fix pointer-events
    setTimeout(() => {
      const gleapIframe = document.querySelector('iframe[src*="gleap"]');
      if (gleapIframe) {
        (gleapIframe as HTMLIFrameElement).style.pointerEvents = "auto";
        (gleapIframe as HTMLIFrameElement).style.zIndex = "999999";
      }

      const gleapDivs = document.querySelectorAll('div[class*="gleap"]');
      gleapDivs.forEach((el) => {
        (el as HTMLElement).style.pointerEvents = "auto";
        (el as HTMLElement).style.zIndex = "999999";
      });
    }, 1000); // 1 second is usually safe, tweak if needed
  };

  const handleLogout = async (goback_url: string) => {
    try {
      console.warn("handleLogout");
      Gleap.clearIdentity();
      Gleap.close();

      resetAppStateLogin();
      const adminToken = localStorage.getItem("lastToken");

      if (adminToken) {
        const adminId = localStorage.getItem("lastId");
        localStorage.removeItem("lastId");
        localStorage.removeItem("lastToken");
        const token = await loginAs(adminId, adminToken, prefix);
        await signInWithCustomToken(auth, token);
        navigateWorkspace("/home");
        await logoutUser();
      } else {
        await logoutUser();
        if (goback_url) {
          navigateWorkspace(goback_url);
        } else {
          navigateWorkspace("/login"); // Navigate to "entree" after logout
        }
      }
      //setUpdateListeners({});
      setUserData(null);
      setOrgData(null);
    } catch (error) {
      console.error("Error logging out:", error);
    }
  };

  const handleLoginAs = async (id: string) => {
    console.warn("handleLoginAs", id);
    Gleap.clearIdentity();
    setUserData(null);
    setOrgData(null);
    // setUpdateListeners({});

    try {
      if (!id) {
        console.error("Invalid user id");
        return;
      }
      if (!currentUser) {
        console.error("No current user found. Please log in first.");
        return;
      }

      // if id is an object, extract the id
      if (typeof id === "object") {
        console.warn("id is an object, extracting id");
      }

      // Sign out the current user before switching
      const token = await currentUser.getIdToken(); // Fetch token from Firebase

      const switch_token = await loginAs(id, token, prefix);
      console.log("switch_token", switch_token);

      // Sign in with the custom token
      await signInWithCustomToken(auth, switch_token);

      // Wait until the currentUser is available
      let refreshedUser = null;
      for (let i = 0; i < 10; i++) {
        refreshedUser = auth.currentUser;
        if (refreshedUser) break;
        await new Promise((resolve) => setTimeout(resolve, 200)); // wait 200ms
      }

      if (!refreshedUser) {
        throw new Error("Failed to retrieve the current user after login.");
      }
      console.log("refreshedUser after loginAs", refreshedUser);
      // Fetch user data based on currentUser uid
      const userData = (await getDocDataById(
        "user",
        refreshedUser.uid
      )) as any as User;
      console.log("userData after loginAs", userData);
      if (!userData || !userData.org_id) {
        throw new Error("Invalid user data or missing org_ref.");
      }

      // Fetch org data
      const orgData = await getDocDataById("org", userData.org_id);

      navigateWorkspace("/home"); // Navigate to a protected route after successful login
    } catch (error) {
      console.error("Error during login:", error);
    }
  };
  const handleInitiate = async (version: any) => {
    if (version) {
      let version2 = await getDocDataById("maintenance", "version");
      handleSetVersion(version2);
      console.log("version2", version2);
    }
  };

  useEffect(() => {
    handleInitiate(version);
    listenDocDataByIdX(
      "maintenance",
      "version",
      handleSetVersion,
      unsubscribeVersion
    );
  }, [version, currentUser]);

  const navigate = useNavigate();
  const navigateWorkspace = (path: string) => {
    navigate(path);
  };

  return (
    <div
      className={`bg-transparent w-full h-screen  flex flex-col ${"pointer-events-auto"}`}
    >
      <div
        className={`
        ${
          location.pathname.includes("/planning")
            ? "bg-neutral-200"
            : location.pathname.includes("iframe")
            ? "bg-transparent"
            : "bg-white"
        }
         w-full h-full  flex sm:flex-row flex-col `}
      >
        <div
          id="MyDiv"
          className="flex h-full w-full items-stretch   flex-grow sm:flex-row  bg-transparent"
        >
          {messageNewVersion && (
            <div
              onClick={() => {
                window.location.reload();
              }}
              className="fixed hover:-translate-y-1 bg-black  w-c600 border-green-400 border-2 hover:scale-105  transition-all duration-300 pointer-events-auto flex items-center justify-center bottom-10 p-1 min-w-fit left-1/2 -translate-x-1/2 z-30 flex-col gap-1 text-white h-fit  shadow-lg rounded-xl cursor-pointer"
            >
              <div className="px-8 py-4 w-full  rounded-xl  flex flex-col gap-1">
                <img
                  src="https://i.ibb.co/Y4Sq7j8N/7859f4e95c80233338160901a962475-rotateda.jpg"
                  className="w-full h-full rounded-xl absolute top-0 left-0 object-cover opacity-100 "
                />
                <div className="flex flex-row gap-10 z-10 justify-between items-center w-full">
                  <div className="flex flex-col gap-2  ">
                    <div className="font-semibold w-full">
                      Une nouvelle version est disponible sur le site.
                    </div>
                    <div className="w-full">
                      Veuillez cliquez ici pour passer à la nouvelle version.
                    </div>
                  </div>
                  <img src={imageLogo} alt="Logo" width={25} height={25} />
                </div>
              </div>
            </div>
          )}
          {isinside && (
            <>
              <div
                className={` flex-col flex min-w-fit h-full  overflow-auto bg-transparent `}
              >
                <NavBar
                  actualpage={actualpage}
                  local_version={version}
                  orgData={orgData}
                  masterData={masterData}
                  userData={userData}
                  navigateWorkspace={navigateWorkspace}
                  handleLogout={handleLogout}
                  handleLoginAs={handleLoginAs}
                />
              </div>{" "}
              <div
                className={` flex-col flex min-w-fit h-full  overflow-auto bg-transparent `}
              >
                {isinside && isinparameters && (
                  <ParametersNavBar
                    actualpage={actualpage}
                    navigateWorkspace={navigateWorkspace}
                    orgData={orgData}
                    userData={userData}
                  />
                )}
              </div>
            </>
          )}

          <div className="flex flex-col w-full h-full bg-transparent ">
            <Suspense fallback={<div></div>}>
              <Routes>
                <Route
                  path="*"
                  element={
                    <RoutesManager
                      userData={userData}
                      handleLogout={handleLogout}
                      navigateWorkspace={navigateWorkspace}
                      orgData={orgData}
                      handleLoginAs={handleLoginAs}
                      actualpage={actualpage}
                      handleClickVariant={handleClickVariant}
                    />
                  }
                />
              </Routes>
            </Suspense>
          </div>
        </div>
      </div>
    </div>
  );
}

export default App;
